/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { Pageable } from '../model/models';
import { PagedModelTipoPraticaOperatoreDTO } from '../model/models';
import { PraticheOperatoreCountersDTO } from '../model/models';
import { PraticheOperatoreCountersFilter } from '../model/models';
import { PraticheOperatoreStatsDTO } from '../model/models';
import { TipoPraticaListFilter } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface CountPraticheOperatoreRequestParams {
    filter: PraticheOperatoreCountersFilter;
}

export interface GetMieTipiPraticaRequestParams {
    filter: TipoPraticaListFilter;
    pageable: Pageable;
}

export interface StatsPraticheOperatoreRequestParams {
    filter: PraticheOperatoreCountersFilter;
}


export interface PraticheVistaOperatoreServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Conteggi delle pratiche aggregati per stato, scoped cross-bando all\&#39;operatore loggato. Scope branchato sull\&#39;authority: SUPERADMIN tutte (comune_id come filtro cross-tenant); ADMIN/OP_COMUNE i bandi dei propri comuniGestiti (nessuna riga user_tipo_pratica richiesta); OP_PRATICA / OP_PRATICA_ESERCENTE solo i bandi assegnati. Filtri opzionali comune_id (dentro lo scope; out-of-scope per i non-SUPERADMIN → 403) e id_tipo_pratica (singolo bando). Tutte le 7 chiavi RichiestaPraticaStatus sempre presenti (zero-fill); le chiavi voucher restano 0 fino a Fase 10bis.
     * 
     * @endpoint get /api/v1/gestione/pratiche/counters
* @param requestParameters
     */
    countPraticheOperatore(requestParameters: CountPraticheOperatoreRequestParams, extraHttpRequestParams?: any): Observable<PraticheOperatoreCountersDTO>;

    /**
     * Lista capability-aware dei TipoPratica visibili all\&#39;operatore loggato. Visibilita\&#39; branchata sull\&#39;authority del caller: OP_COMUNE vede tutti i bandi del proprio comune (capabilities.gestione&#x3D;true); OP_PRATICA / OP_PRATICA_ESERCENTE vedono solo i bandi su cui hanno una riga di assegnazione (capabilities.gestione &#x3D; riga.gestione). Filtri opzionali: tipologia, stato, q, fase, visualizzazione, comune_id, solo_submit_per_cittadino. Default sort: codice ASC. Con solo_submit_per_cittadino&#x3D;true la lista e\&#39; ristretta ai bandi su cui il chiamante puo\&#39; davvero sottomettere per conto del cittadino (capabilities.submit_per_cittadino&#x3D;true): e\&#39; la vista usata dall\&#39;area operatore dell\&#39;app mobile.
     * 
     * @endpoint get /api/v1/gestione/pratiche/me/tipi-pratica
* @param requestParameters
     */
    getMieTipiPratica(requestParameters: GetMieTipiPraticaRequestParams, extraHttpRequestParams?: any): Observable<PagedModelTipoPraticaOperatoreDTO>;

    /**
     * Aggregati monetari delle pratiche/voucher, scoped cross-bando all\&#39;operatore loggato (card KPI dashboard). Scope branchato sull\&#39;authority come i counters: SUPERADMIN tutte (comune_id come filtro cross-tenant); ADMIN/OP_COMUNE i bandi dei propri comuniGestiti; OP_PRATICA / OP_PRATICA_ESERCENTE solo i bandi assegnati. Filtri opzionali comune_id (dentro lo scope; out-of-scope per i non-SUPERADMIN → 403) e id_tipo_pratica (singolo bando). Importi BigDecimal scala 2, mai null (COALESCE a 0).
     * 
     * @endpoint get /api/v1/gestione/pratiche/stats
* @param requestParameters
     */
    statsPraticheOperatore(requestParameters: StatsPraticheOperatoreRequestParams, extraHttpRequestParams?: any): Observable<PraticheOperatoreStatsDTO>;

}
